import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IChatMessageModel } from '../../../../../models/chat-message.model';
import { ChatService } from '../../../../../../services/chat.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditMessageDialog } from '../../../edit-message-dialog/edit-message-dialog.component';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faEllipsis, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { IUser } from '../../../../../models/user.model';

@Component({
  selector: 'app-message-item',
  templateUrl: './message-item.component.html',
  styleUrls: ['./message-item.component.scss']
})
export class MessageItemComponent implements OnInit {

  @Input() ownMessage: boolean;
  @Input() message: IChatMessageModel;
  @Input() user: IUser;
  @Output() editClicked = new EventEmitter();
  image = './content/images/avatar2.png';
  thumbsUpIcon: IconDefinition = faThumbsUp;
  ellipsisIcon = faEllipsis;

  constructor(private chatService: ChatService, private modalService: NgbModal) { }

  ngOnInit() {
  }

  editMessage() {
    const dialogInst = this.modalService.open(EditMessageDialog, {
      backdrop: 'static',
    });
    const dialog = dialogInst.componentInstance as EditMessageDialog;
    dialog.message = this.message;
  }

  deleteMessage() {
    this.chatService.deleteMessage(this.message.id).subscribe((result) => {
      if (result) {
        this.message.isActive = false;
      }
    })
  }
}
